import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getPetitionCommentsPageData } from './api';
import type { PetitionCommentsPageDataErrorCode } from './types';

export const {
	Context: PetitionCommentsPageDataContext,
	Provider: PetitionCommentsPageDataContextProvider,
	useContext: usePetitionCommentsPageData,
	useAsyncData: usePetitionCommentsPageDataFromApi,
	prefetchAsyncData: prefetchPetitionCommentsPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PetitionCommentsPageDataContext',
	dataProperty: 'pageData',
	getData: getPetitionCommentsPageData,
	getUniqueId: (slug) => slug,
	errorHandler: pageDataErrorHandler<PetitionCommentsPageDataErrorCode>(),
});
